/* Proaid Nutrition — collection page: sort + filter form submission.
   Sorting and filtering reload the page with Shopify's native query
   params (sort_by + filter.*), so results are server-rendered. */
(function () {
  'use strict';

  var form = document.querySelector('[data-collection-filters]');
  if (!form) return;

  function apply() {
    var url = new URL(window.location.href);
    var params = new URLSearchParams();

    /* Preserve nothing but filters + sort; drop page so results restart */
    var formData = new FormData(form);
    formData.forEach(function (value, key) {
      if (value !== '') params.append(key, value);
    });

    url.search = params.toString();
    window.location.href = url.toString();
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    apply();
  });

  form.addEventListener('change', function (event) {
    if (event.target.matches('[data-sort-by]') || event.target.matches('input[type="checkbox"]')) {
      apply();
    }
  });
})();
